import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import { NewButton } from "./index";

export const TracksWeb = () => {
   const tracks = [
      {
         name: "TECH",
         icon: "./assets/events/fvs22/fluent_power-28-regular.png",
         borderColor: "#092cab",
         background: "url('./assets/media/unsplash_Bd7gNnWJBkU (3).png')",
         list: [
            "mobile",
            "internet/digital marketing",
            "IoT",
            "security",
            "software/IT",
            "edtech",
            "robotics",
            "proptech",
         ],
      },
      {
         name: "FINTECH",
         icon: "./assets/events/fvs22/clarity_bank-line.png",
         borderColor: "#1551ea",
         background: "url('./assets/media/unsplash_JrjhtBJ-pGU (3).png')",
         list: [
            "banking",
            "blockchain",
            "insurtech",
            "personal finance",
            "payments",
            "predictive analytics",
         ],
      },
      {
         name: "CLEANTECH",
         icon: "./assets/events/fvs22/Vector.png",
         borderColor: "#1170FF",
         background: "url('./assets/media/unsplash_xG79esLZJ7U ().png')",
         list: [
            "energy efficiency",
            "energy generation",
            "energy infrastructure",
            "energy storage",
            "transportation",
            "water & wastewater",
            "agritech",
            "climate tech"
         ],
      },
      {
         name: "MEDTECH",
         icon: "./assets/events/fvs22/Vector (1).png",
         borderColor: "#107EFF",
         background: "url('./assets/media/unsplash_7wWRXewYCH4 (2).png')",
         list: [
            "medical devices",
            "diagnostics",
            "monitoring",
            "wearables",
            "AI solutions",
            "medical AR",
         ],
      },
      {
         name: "LIFESCIENCES & HEALTHCARE",
         icon: "./assets/events/fvs22/Vector (2).png",
         borderColor: "#10A9FF",
         background: "url('./assets/media/unsplash_UIp163xCV6w (2).png')",
         list: [
            "biotech",
            "drug discovery",
            "healthcare IT",
            "pharma",
            "healthcare",
         ],
      },
      {
         name: "SEED STAGE",
         icon: "./assets/events/fvs22/teenyicons_plant-outline.png",
         borderColor: "#10C6FF",
         background: "url('./assets/media/unsplash_UIp163xCV6w (2).png')",
         list: [
            "tech",
            "fintech",
            "cleantech",
            "medtech",
            "lifesciences",
            "healthcare",
         ],
      },
   ];
   return (
      <div style={{ backgroundColor: "black" }}>
         {!window.location.href.includes("top-innovators") && (
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  justifyContent: "center",
                  gap: "15px",
                  padding: "2.5%",
                  paddingTop: 0
               }}
            >
               <h1
                  style={{
                     textAlign: "center",
                     fontWeight: "900",

                     background: "linear-gradient(90deg, #00C2FF, #092CA8)",
                     WebkitBackgroundClip: "text",
                     color: "transparent",

                     fontSize: "3rem",
                     margin: '2.5% auto'
                  }}
               >
                  CALL FOR TOP INNOVATORS!
               </h1>

               <h5
                  style={{
                     width: window.innerWidth < 769 ? "100%" : "50%",
                     textAlign: "center",
                     margin: "auto",
                     color: "white",
                  }}
               >
                  A select group of more than <b>100 Top Innovators</b> from the
                  following sectors will be chosen to present their breakthrough
                  investment opportunities to an exclusive audience of{" "}
                  <b>
                     Venture Capitalists, Corporate Investors, Private Investors,
                     Investment Bankers, and Strategic Partners.
                  </b>
               </h5>
            </div>
         )}

         {window.location.href.includes("top-innovators") && <h1
            style={{
               textAlign: "center",
               paddingTop: "2.5%",
               paddingBottom: "0",
               fontWeight: "900",
               textTransform: "uppercase",
               color: "white"
            }}
         >
            Featured Industries
         </h1>}

         <div className="tracks-container">
            {tracks.map((track, i) => {
               return (
                  <Paper
                     elevation={15}
                     key={i}
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                        backgroundSize: "100% 100%",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "2.5% 1%",
                        border: "5px solid " + track.borderColor,
                        minWidth: "260px",
                        maxWidth: "260px",
                        borderRadius: "20px",
                        margin: window.innerWidth < 769 ? "20px auto" : "20px",
                     }}
                  >
                     <img
                        alt='company-logo'
                        src={track.icon}
                        style={{
                           width: "66px",
                           height: "66px",
                           objectFit: "scale-down",
                           margin: "auto",
                        }}
                     />
                     <h5
                        style={{
                           textAlign: "center",
                           margin: "5% 0",
                           fontWeight: "900",
                           height: "10%",
                        }}
                     >
                        {track.name}
                     </h5>
                     <List sx={{ color: "black", height: "75%" }}>
                        {track.list.map((item, i) => {
                           if (i === 0 || i === track.list.map.length - 1) {
                              return (
                                 <ListItem
                                    key={i}
                                    sx={{
                                       textAlign: "center",
                                       justifyContent: "center",
                                       textTransform: "capitalize",
                                    }}
                                 >
                                    {item}
                                 </ListItem>
                              );
                           } else {
                              return (
                                 <div key={i}>
                                    <Divider sx={{ background: "black" }} />
                                    <ListItem
                                       sx={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                          textTransform: "capitalize",
                                       }}
                                    >
                                       {item}
                                    </ListItem>
                                 </div>
                              );
                           }
                        })}
                     </List>
                  </Paper>
               );
            })}
         </div>

         {!window.location.href.includes("top-innovators") ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
               <h1
                  style={{
                     color: "white",
                     width: "100%",
                     textAlign: "center",
                     fontWeight: "900",
                  }}
               >
                  <span style={{ color: "white" }}>Get Noticed</span> <span style={{ color: '#00C2FF' }}>»</span>{" "}
                  <span style={{ color: "white" }}>Get Funded</span> <span style={{ color: '#00C2FF' }}>»</span>{" "}
                  <span style={{ color: "white" }}>Grow Faster</span>
               </h1>
               <div style={{ width: window.innerWidth < 900 ? "100%" : ' max(15%, 350px)', margin: '2.5% auto 7.5% auto' }}>
                  <NewButton name="Apply Now" link={"https://account.youngstartup.com"} color={"white"} bgColor={"#00C2FF"} />
               </div>
            </div>
         ) :
            <div style={{ display: "flex", flexDirection: "column" }}>
               <h1
                  style={{
                     color: "white",
                     width: "100%",
                     textAlign: "center",
                     fontWeight: "900",
                  }}
               >
                  <span style={{ color: "#092CA8" }}>Get Noticed</span>  <span style={{ color: 'white' }}>»</span>{" "}
                  <span style={{ color: "#1070FF" }}>Get Funded</span>  <span style={{ color: 'white' }}>»</span>{" "}
                  <span style={{ color: "#00C2FF" }}>Grow Faster</span>
               </h1>
               <div style={{ width: window.innerWidth < 900 ? "100%" : '15%', margin: '2.5% auto 2% auto' }}>
                  <NewButton name="Apply Now" link={"https://account.youngstartup.com"} color={"white"} bgColor={"#00C2FF"} />
               </div>
            </div>
         }
      </div>
   );
};
